import { Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#09090b] text-white grid place-items-center px-6">
      <div className="text-center">
        <span className="inline-grid place-items-center w-14 h-14 rounded-2xl bg-[#f5a623]/12 border border-[#f5a623]/30 text-[#f5a623]">
          <Zap size={28} fill="currentColor" />
        </span>
        <p className="mt-8 text-7xl font-black tracking-tighter text-[#f5a623]">404</p>
        <h1 className="mt-3 text-2xl font-extrabold tracking-tight">{t.notFound.title}</h1>
        <p className="mt-2 text-[#a1a1aa]">{t.notFound.text}</p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-8 inline-flex rounded-full bg-[#f5a623] text-[#09090b] font-bold px-6 py-3 hover:bg-[#ffbb3d] transition-colors"
        >
          {t.notFound.cta}
        </Link>
      </div>
    </div>
  );
}
